<app-gmao-spinner *ngIf="!equipments"></app-gmao-spinner>
<ng-container *ngIf="equipments">
    <div class="table-responsive">
        <table class="table table-hover">
            <tbody>
                <ng-container *ngFor="let equipment of equipments.machine_unites">
                    <tr [ngClass]="{'removed' : !equipment.installed}" (click)="getMatPage(equipment.id_mat_unite)">
                        <td class="material-icons">{{equipment.maticon}}</td>
                        <td>{{equipment.classe}} - <i>{{equipment.materiel_designation}}</i></td>
                        <td> <i>s/n :</i> {{equipment.numero_serie}}</td>
                        <td> <i>@mac :</i> {{equipment.adresse_mac}}</td>
                        <ng-container *ngIf="equipment.installed">
                            <td>Monté le {{equipment.date_last_action}}</td>
                            <td></td>
                        </ng-container>
                        <ng-container *ngIf="!equipment.installed">
                            <td></td>
                            <td>Démonté le {{equipment.date_last_action}}</td>
                        </ng-container>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</ng-container>